import { TutorialInfoList } from "../types/info";

export const TUTORIAL_INFO_LIST: TutorialInfoList = [
    {
        text: "You can simply select a ship to place, then click on the available square to place. You can also use spacebar or rotate button to rotate.",
        imgSrc: "/images/place-ships.gif",
        imgAlt: "Placing Ships",
    },
    {
        text: "For you sake, our game also lets you randomize your ship placement to save time.",
        imgSrc: "/images/randomize-ships.gif",
        imgAlt: "Random Ships",
    },
    {
        text: "Your goal is to destroy all of enemy shps before they destroy all of yours. ",
        imgSrc: "/images/cannon-fire.gif",
        imgAlt: "Destroy Enemy Ships ",
    },
];
